/**
 * basic-drawer-menu.js
 */

import React from 'react';
import { useLocation, useRouteMatch, matchPath } from "react-router-dom";
import DrawerMenu from 'components/menu-drawer/menu';
import DrawerMenuItem from 'components/menu-drawer/menu/drawer-menu-item';
import ScrollableList from 'components/scrollable-list';


export default function BasicDrawerMenu(props) {
  const { 
    header,
    footer,
    items,
    baseUrl
  } = props;
  const location = useLocation();
  const { url: matchedBaseUrl } = useRouteMatch();
  const url = baseUrl || matchedBaseUrl;


  const isActive = (path) => {
    return Boolean(matchPath(location.pathname, { path, exact: true }));
  }

  const activeItem = items.find(i => {
    const itemPath = i.to?.pathname || `${url}${i.path}`;
    return isActive(i.isDefaultPage ? [url, itemPath] : [itemPath]);
  });

  
  return (
    <DrawerMenu 
      header={header}
      footer={footer || activeItem?.backgroundImage || null}
      menuGroups={[{ 
        name: '',
        scrollable: true,
        component: ScrollableList,
        items: <>
          {items.map(({ key, iconName, label, labelSub, labelEnd, path, to, disabled }) => (
            <DrawerMenuItem 
              id={key}
              key={key}
              to={to || `${url}${path}`}
              iconName={iconName}
              label={label}
              labelSub={labelSub}
              labelEnd={labelEnd}
              isActive={key === activeItem?.key}
              disabled={disabled}
            />
          ))}
        </>
      }]}
    />
  );
}